module.exports = __webpack_public_path__ + "static/media/reclamation-icon.ac9c3d2b.svg";